import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    width: {
      xs: '100%',
      md: '400px',
    },
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  image: {
    width: '100%',
    height: { xs: '400px', md: '456px' },
    borderRadius: '16px',
    objectFit: 'cover',
    background:
      'linear-gradient(180deg, rgba(0, 0, 0, 0.175) 64.42%, rgba(0, 0, 0, 0.35) 100%)',
  },
  tagsWrapper: {
    position: 'absolute',
    top: '32px',
    left: '32px',
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  tag: {
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 16px',
    borderRadius: '32px',
    whiteSpace: 'nowrap',
    color: 'text.primaryDark',
    backgroundColor: '#FFFFFF0D',
    backdropFilter: 'blur(20px)',
    boxShadow: '0px 4px 15px 0px #00000026',
    outline: '1px solid',
    outlineColor: '#FFFFFF26',
  },

  info: {
    position: 'absolute',
    left: '20px',
    right: '20px',
    bottom: '32px',
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    color: 'rgba(255, 255, 255, 0.6)',
  },
  gradientCover: {
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(180deg, rgba(0, 0, 0, 0.175) 64.42%, rgba(0, 0, 0, 0.35) 100%)',
    pointerEvents: 'none',
    borderRadius: '16px',
  },

  statsCardWrapper: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    marginTop: '12px',
  },
  titleRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    maxWidth: '100%',
  },
  title: {
    minWidth: 0,
  },
  titleIcon: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },
  textWrapper: {},
  infoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
